import { render, staticRenderFns } from "./BackendLeftNav.vue?vue&type=template&id=59d2b4f9&scoped=true"
import script from "./BackendLeftNav.vue?vue&type=script&lang=js"
export * from "./BackendLeftNav.vue?vue&type=script&lang=js"
import style0 from "./BackendLeftNav.vue?vue&type=style&index=0&id=59d2b4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2b4f9",
  null
  
)

export default component.exports